import {config} from "../config.ts";
import {useRecoilState} from "recoil";
import {userAccountInfoAtom} from "../state/users.ts";
import axios from "axios";
import {useGetHeaders} from "../hooks/useHeaders.ts";
import {useMsal} from "@azure/msal-react";

export interface AuthActions {
    getUserInfo: (isAuthenticated: boolean) => Promise<void>;
}

export const useAuthActions = (): AuthActions => {
    const [, setUserAccountInfo] = useRecoilState(userAccountInfoAtom);
    const {accounts} = useMsal()
    const getHeaders = useGetHeaders()

    return {
        getUserInfo
    }

    async function getUserInfo(isAuthenticated: boolean): Promise<void> {
        const result = await axios.get(config.baseUrl + "users/info", await getHeaders()).catch(catchError)
        if(result && result.status < 400){
            console.log("GET user info", result.data)
            setUserAccountInfo({ isAuthenticated: isAuthenticated, account: accounts[0], user: result.data.user, roles: result.data.roles, manager_of_group_ids: result.data.manager_of_group_ids})
        }
    }
    
    function catchError (e: any) {
        if (e?.response?.status === 403){
            setUserAccountInfo({isAuthenticated: false, account: null, manager_of_group_ids: [], user: null, roles: []})
            window.location.href = `${import.meta.env.VITE_REDIRECT_URL}#/not-enough-privileges`
        }
    }
}
